import { connect } from 'react-redux'
import R from 'ramda'
import { PAGES } from '../../constants'

import { setNavigation } from '_actions'

import {
  fetch,
  fetchList,
  patch,
  addNote,
  removeNote,
  createLicense,
  reactivateLicense,
  modifyLicense,
  removeLicense,
  removeLicenseMachine,
  createSublicense,
  modifySublicense,
  removeSublicense,
  deactivateLicenseUpgrade,
  fetchAutocompleteSuggestions,
  setAutocompleteSelections,
  clearAutocompleteSuggestions
} from '_actions/users'

import Users from './page'

const mapStateToProps = state => ({
  usersPage: R.pathOr({}, ['pages', PAGES.USERS], state)
})

const mapDispatchToProps = dispatch => ({
  // user actions
  onRefreshUser: R.compose(dispatch, fetch), // ({userId})
  onRemoveUser: () => dispatch({type: 'noaction'}),
  onModifyUser: R.compose(dispatch, patch), // ({userId, payload})

  setNavigation: R.compose(dispatch, setNavigation), // navigation
  goToPage: R.compose(dispatch, setNavigation, R.merge(R.__, {pageName: PAGES.USERS})), // navigation
  onRefreshList: R.compose(dispatch, fetchList), // navigation, aka R.pathOr({}, ['pages', PAGES.INSTITUTIONS, 'navigation'], this.props.state)

  // main user autocomplete
  onTermChange: R.compose(dispatch, fetchAutocompleteSuggestions), // {term,pageNum}
  onSelectionChange: R.compose(dispatch, setAutocompleteSelections), // selections
  onClearSuggestions: R.compose(dispatch, clearAutocompleteSuggestions), // selections
  // notes actions
  onAddNote: R.compose(dispatch, addNote), // ({userId, payload})
  onRemoveNote: R.compose(dispatch, removeNote), // ({userId, noteId})
  // license actions
  onAddLicense: R.compose(dispatch, createLicense), // ({userId, payload})
  onReactivateLicense: R.compose(dispatch, reactivateLicense), // ({userId, licenseId})
  onModifyLicense: R.compose(dispatch, modifyLicense), // ({userId, licenseId, payload})
  onRemoveLicense: R.compose(dispatch, removeLicense), // ({userId, licenseId})
  onRemoveLicenseMachine: R.compose(dispatch, removeLicenseMachine), // ({userId, licenseId, machineId})
  onDeactivateLicenseUpgrade: R.compose(dispatch, deactivateLicenseUpgrade), // ({userId, licenseId, licenseUpgradeId})
  // sublicense actions
  onAddSublicense: R.compose(dispatch, createSublicense), // ({userId, licenseId, payload})
  onModifySublicense: R.compose(dispatch, modifySublicense), // ({userId, licenseId, sublicenseId, payload})
  onRemoveSublicense: R.compose(dispatch, removeSublicense), // ({userId, licenseId, sublicenseId})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users)



// WEBPACK FOOTER //
// ./webAdmin/components/users/index.js